//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import basePath from '../../../../../../common/functions/api-resource';
import exportacao from '../../../../../../common/resources/downloads';

export default {
  data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      evidencias: [],
    };
  },
  methods: {
    fechar() {
      this.$refs.modal.close();
    },
    abrir(idMeta) {
      const id = idMeta;
      this.execucaoResources.listar({ id }, { id })
      .then((response) => {
        this.evidencias = response.data;
        this.$refs.modal.open();
      })
      .catch((err) => {
        this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    visualizarArquivo(row) {
      const getBasePath = basePath('execucao', 'execucao');
      const resource = exportacao(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: `${row.id}/pdf`,
      })
      .catch(() => {
        this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/ExecucaoModal.vue?vue&type=script&lang=js&